var map = {
	"./CartIcon": "0815",
	"./CartIcon.vue": "0815",
	"./Drag.svg": "ecae",
	"./analyse.png": "09f5",
	"./arrow-down.svg": "76bd",
	"./arrow.svg": "27e4",
	"./bag-2.svg": "895d",
	"./box-tick.svg": "ba4f",
	"./close.svg": "2930",
	"./copy-to-clipboard.png": "a008",
	"./cross.svg": "4915",
	"./dive.png": "5396",
	"./edit.svg": "b0e3",
	"./epicenter_logo.png": "6a71",
	"./forgot-password-email-sent-framme-store.png": "4544",
	"./forgot-password-framme-store.png": "0c83",
	"./framme-store-demo.jpg": "7db6",
	"./framme_logo_black.png": "1056",
	"./grab-handle.svg": "50ae",
	"./grid-view-active.svg": "cdfe",
	"./grid-view-inactive.svg": "d480",
	"./hamburger-close.svg": "ad15",
	"./hamburger.svg": "a52e",
	"./inventory.svg": "3ac8",
	"./juho-wolt.jpg": "a8e4",
	"./list-view-active.svg": "0492",
	"./list-view-inactive.svg": "2fb5",
	"./logout-1.svg": "c397",
	"./logout.svg": "4488",
	"./magic-brand.png": "68fa",
	"./magicpen.svg": "1483",
	"./no-active-stores.png": "8a47",
	"./one-off-link-expired.jpg": "cb6f",
	"./order-confirmed.png": "821d",
	"./pia-forenom.jpg": "9f16",
	"./product-photo-coming-soon-small.jpg": "3384",
	"./product-photo-coming-soon.jpg": "9320",
	"./profile-circle.svg": "2dba",
	"./reset-password-framme-store.png": "c252",
	"./sam-and-the-brand-logo-dark.svg": "970b",
	"./setting-2.svg": "b655",
	"./stack-stack.png": "6736",
	"./tooltip.svg": "0234c",
	"./warning-framme-store.png": "65b7",
	"./whoopsie-image-grey.png": "a44b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";